import { ScrollController } from '../../../../shared/features/scroll-controller';

/**
 * Глобальный экземпляр контроллера скролла для списка участников
 * Используется как в saga (handleMeetingRoomMessage), так и в компоненте (ParticipantsSidebar)
 */
export const participantsScrollController = new ScrollController();
